<template>
  <GmapMap
    class="overide-vue-map"
    :center="position"
    :zoom="zoom"
    :options="{ disableDefaultUI: true, keyboardShortcuts: false }"
    :style="`
      width: ${width};
      height: ${height};
    `"
  >
    <GmapMarker
      :position="position"
      :draggable="!readonly"
      @dragend="onPositionChange"
      :icon="{ url: markerIcon, scaledSize: markerSize }"
    />
  </GmapMap>
</template>

<script>
  export default {
    name: "Gmap",
    props: {
      position: {
        default: () => ({ lat: 0, lng: 0 })
      },
      width: {
        default: '100%'
      },
      height: {
        default: '100%'
      },
      zoom: {
        default: 17
      },
      markerIcon: {
        default: null
      },
      markerSize: {
        default: null // { height: number, width: number }
      },
      readonly: {
        default: false
      }
    },
    methods: {
      onPositionChange: function(position) {
        if (this.readonly) return
        this.$emit('change', position)
      }
    }
  }
</script>

<style lang="scss" scoped>
.overide-vue-map {
  border-radius: inherit;
  
  /deep/ {
    .vue-map {
      border-radius: inherit;
      width: 100%;
      height: 100%;
    }

  } 
}

</style>


// WEBPACK FOOTER //
// src/components/element/Gmap.vue